































import Vue from "vue";
import { mapGetters } from "vuex";
import iwModal from "../../shared/components/Modal.vue";

export default Vue.extend({
    components: {
        iwModal: iwModal,
    },

    data: function() {
        return {
            isCorrectlyCloseEdition: false,
            isLoading: false
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),
        isEditionModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isEditionModalOpen"];
        },
        modalTitle: function(): string {
            return this.$t("attention_title") as string;
        }
    },

    methods: {
        closeEditionModal: function(): void {
            this.$store.commit("ModalModule/closeEditionModal");
        },
        openEditionModal: function(): void {
            this.$store.commit("ModalModule/openEditionModal");
        },
        cancelModification: function(): void {
            let urlTranslated = this.$t("my-immoweb") as string;
            const to = this.$router.resolve({path: urlTranslated});
            this.$router.push(to.location);
            this.closeEditionModal();
        }
    }
});

